import { render, staticRenderFns } from "./BindOperate.vue?vue&type=template&id=28a5989e&scoped=true"
import script from "./BindOperate.vue?vue&type=script&lang=js"
export * from "./BindOperate.vue?vue&type=script&lang=js"
import style0 from "./BindOperate.vue?vue&type=style&index=0&id=28a5989e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5989e",
  null
  
)

export default component.exports